import { Contact } from 'src/app/hickory-api';
import { DataGenerator } from './DataGenerator';

export class ContactData extends DataGenerator<Contact> {
  static instance = new ContactData();

  protected createPredefined(): Contact[] {
    // Casing is wrong in swagger.json for PhoneNumber (actual is lower pascal, swagger has upper pascal)
    const json: any[] = [
      {
        id: 4578,
        firstName: 'Eighty',
        lastName: '*Aalpha',
        emails: [
          {
            address: '9080mobiledev@nagdom.com'
          }
        ],
        phones: [
          {
            number: '208-555-0002',
            priority: 0,
            phoneType: 'Business'
          },
          {
            number: '(208) 982-0291',
            priority: 0,
            phoneType: 'Cell'
          }
        ],
        importedId: 'LP080',
        chatUser: {
          id: ''
        },
        chatIdentity: {
          id: ''
        }
      },
      {
        id: 4582,
        firstName: 'FaxMan',
        lastName: '*Aalpha',
        emails: [],
        phones: [
          {
            number: '(208) 424-3079',
            priority: 0,
            phoneType: 'Fax'
          }
        ],
        importedId: 'ST002',
        chatUser: {
          id: ''
        },
        chatIdentity: {
          id: ''
        }
      },
      {
        id: 4581,
        firstName: 'Multi-Address',
        lastName: '*Aalpha',
        emails: [],
        phones: [],
        importedId: 'ST001',
        chatUser: {
          id: ''
        },
        chatIdentity: {
          id: ''
        }
      },
      {
        id: 4583,
        firstName: 'NoMailOne',
        lastName: '*Aalpha',
        emails: [],
        phones: [
          {
            number: '(208) 283-5526',
            priority: 0,
            phoneType: 'Cell'
          }
        ],
        importedId: 'ST003',
        chatUser: {
          id: ''
        },
        chatIdentity: {
          id: ''
        }
      },
      {
        id: 4584,
        firstName: 'NoMailTwo',
        lastName: '*Aalpha',
        emails: [],
        phones: [
          {
            number: '(208) 982-0291',
            priority: 0,
            phoneType: 'Cell'
          }
        ],
        importedId: 'ST004',
        chatUser: {
          id: ''
        },
        chatIdentity: {
          id: ''
        }
      },
      {
        id: 4579,
        firstName: 'ThirtyOne',
        lastName: '*Aalpha',
        emails: [
          {
            address: '9031mobiledev@nagdom.com'
          }
        ],
        phones: [
          {
            number: '208-555-0002',
            priority: 0,
            phoneType: 'Business'
          },
          {
            number: '(208) 971-7549',
            priority: 0,
            phoneType: 'Cell'
          }
        ],
        importedId: 'LP031',
        chatUser: {
          id: ''
        },
        chatIdentity: {
          id: ''
        }
      },
      {
        id: 4580,
        firstName: 'Twenty-Nine',
        lastName: '*Aalpha',
        emails: [
          {
            address: '9029mobiledev@nagdom.com'
          }
        ],
        phones: [
          {
            number: '208-555-0002',
            priority: 0,
            phoneType: 'Business'
          },
          {
            number: '(208) 906-7681',
            priority: 0,
            phoneType: 'Cell'
          }
        ],
        importedId: 'LP029',
        chatUser: {
          id: ''
        },
        chatIdentity: {
          id: ''
        }
      },
      {
        id: 4577,
        firstName: 'Two-Seventeen',
        lastName: '*Aalpha',
        emails: [
          {
            address: '9217mobiledev@nagdom.com'
          }
        ],
        phones: [
          {
            number: '208-555-0001',
            priority: 0,
            phoneType: 'Business'
          },
          {
            number: '(208) 283-5526',
            priority: 0,
            phoneType: 'Cell'
          }
        ],
        importedId: 'LP217',
        chatUser: {
          id: ''
        },
        chatIdentity: {
          id: ''
        }
      },
      {
        id: 4591,
        firstName: 'TestAdmin',
        lastName: '*LockedFSMAG',
        emails: [
          {
            address: '8508mobiledev@nagdom.com'
          }
        ],
        phones: [],
        importedId: 'LA8508',
        chatUser: {
          id: ''
        },
        chatIdentity: {
          id: ''
        }
      },
      {
        id: 4588,
        firstName: 'TestAdmin',
        lastName: '*LockedFullSend',
        emails: [
          {
            address: '8504mobiledev@nagdom.com'
          }
        ],
        phones: [],
        importedId: 'LA8504',
        chatUser: {
          id: ''
        },
        chatIdentity: {
          id: ''
        }
      },
      {
        id: 4589,
        firstName: 'TestAdmin',
        lastName: '*LockedHBPMAG',
        emails: [
          {
            address: '8506mobiledev@nagdom.com'
          }
        ],
        phones: [],
        importedId: 'LA8506',
        chatUser: {
          id: ''
        },
        chatIdentity: {
          id: ''
        }
      },
      {
        id: 4585,
        firstName: 'TestAdmin',
        lastName: '*LockedHiltonBcmPmo',
        emails: [
          {
            address: '8501mobiledev@nagdom.com'
          }
        ],
        phones: [],
        importedId: 'LA8501',
        chatUser: {
          id: ''
        },
        chatIdentity: {
          id: ''
        }
      },
      {
        id: 4586,
        firstName: 'TestAdmin',
        lastName: '*LockedReceiveOnly',
        emails: [
          {
            address: '8502mobiledev@nagdom.com'
          }
        ],
        phones: [],
        importedId: 'LA8502',
        chatUser: {
          id: ''
        },
        chatIdentity: {
          id: ''
        }
      },
      {
        id: 4587,
        firstName: 'TestAdmin',
        lastName: '*LockedSimplifiedSend',
        emails: [
          {
            address: '8503mobiledev@nagdom.com'
          }
        ],
        phones: [],
        importedId: 'LA8503',
        chatUser: {
          id: ''
        },
        chatIdentity: {
          id: ''
        }
      },
      {
        id: 4590,
        firstName: 'TestAdmin',
        lastName: '*LockedSSMAG',
        emails: [
          {
            address: '8507mobiledev@nagdom.com'
          }
        ],
        phones: [],
        importedId: 'LA8507',
        chatUser: {
          id: ''
        },
        chatIdentity: {
          id: ''
        }
      },
      {
        id: 4505,
        firstName: 'alpha-001',
        lastName: 'alpha',
        emails: [
          {
            address: 'G-001mobiledev@nagdom.com'
          }
        ],
        phones: [
          {
            number: '208-555-0001',
            priority: 0,
            phoneType: 'Business'
          },
          {
            number: '(208) 283-5526',
            priority: 0,
            phoneType: 'Cell'
          }
        ],
        importedId: 'GM001',
        chatUser: {
          id: ''
        },
        chatIdentity: {
          id: ''
        }
      },
      {
        id: 4506,
        firstName: 'beta-002',
        lastName: 'alpha',
        emails: [
          {
            address: 'G-002mobiledev@nagdom.com'
          }
        ],
        phones: [
          {
            number: '208-555-0002',
            priority: 0,
            phoneType: 'Business'
          },
          {
            number: '(208) 982-0291',
            priority: 0,
            phoneType: 'Cell'
          }
        ],
        importedId: 'GM002',
        chatUser: {
          id: ''
        },
        chatIdentity: {
          id: ''
        }
      },
      {
        id: 4507,
        firstName: 'chi-003',
        lastName: 'alpha',
        emails: [
          {
            address: 'G-003mobiledev@nagdom.com'
          }
        ],
        phones: [
          {
            number: '208-555-0003',
            priority: 0,
            phoneType: 'Business'
          },
          {
            number: '(208) 283-5526',
            priority: 0,
            phoneType: 'Cell'
          }
        ],
        importedId: 'GM003',
        chatUser: {
          id: ''
        },
        chatIdentity: {
          id: ''
        }
      },
      {
        id: 4508,
        firstName: 'delta-004',
        lastName: 'alpha',
        emails: [
          {
            address: 'G-004mobiledev@nagdom.com'
          }
        ],
        phones: [
          {
            number: '208-555-0004',
            priority: 0,
            phoneType: 'Business'
          },
          {
            number: '(208) 982-0291',
            priority: 0,
            phoneType: 'Cell'
          }
        ],
        importedId: 'GM004',
        chatUser: {
          id: ''
        },
        chatIdentity: {
          id: ''
        }
      },
      {
        id: 4509,
        firstName: 'epsilon-005',
        lastName: 'alpha',
        emails: [
          {
            address: 'G-005mobiledev@nagdom.com'
          }
        ],
        phones: [
          {
            number: '208-555-0005',
            priority: 0,
            phoneType: 'Business'
          },
          {
            number: '(208) 283-5526',
            priority: 0,
            phoneType: 'Cell'
          }
        ],
        importedId: 'GM005',
        chatUser: {
          id: ''
        },
        chatIdentity: {
          id: ''
        }
      },
      {
        id: 4510,
        firstName: 'eta-006',
        lastName: 'alpha',
        emails: [
          {
            address: 'G-006mobiledev@nagdom.com'
          }
        ],
        phones: [
          {
            number: '208-555-0006',
            priority: 0,
            phoneType: 'Business'
          },
          {
            number: '(208) 982-0291',
            priority: 0,
            phoneType: 'Cell'
          }
        ],
        importedId: 'GM006',
        chatUser: {
          id: ''
        },
        chatIdentity: {
          id: ''
        }
      },
      {
        id: 4511,
        firstName: 'gamma-007',
        lastName: 'alpha',
        emails: [
          {
            address: 'G-007mobiledev@nagdom.com'
          }
        ],
        phones: [
          {
            number: '208-555-0007',
            priority: 0,
            phoneType: 'Business'
          },
          {
            number: '(208) 283-5526',
            priority: 0,
            phoneType: 'Cell'
          }
        ],
        importedId: 'GM007',
        chatUser: {
          id: ''
        },
        chatIdentity: {
          id: ''
        }
      },
      {
        id: 4512,
        firstName: 'iota-008',
        lastName: 'alpha',
        emails: [
          {
            address: 'G-008mobiledev@nagdom.com'
          }
        ],
        phones: [
          {
            number: '208-555-0008',
            priority: 0,
            phoneType: 'Business'
          },
          {
            number: '(208) 982-0291',
            priority: 0,
            phoneType: 'Cell'
          }
        ],
        importedId: 'GM008',
        chatUser: {
          id: ''
        },
        chatIdentity: {
          id: ''
        }
      },
      {
        id: 4513,
        firstName: 'kappa-009',
        lastName: 'alpha',
        emails: [
          {
            address: 'G-009mobiledev@nagdom.com'
          }
        ],
        phones: [
          {
            number: '208-555-0009',
            priority: 0,
            phoneType: 'Business'
          },
          {
            number: '(208) 283-5526',
            priority: 0,
            phoneType: 'Cell'
          }
        ],
        importedId: 'GM009',
        chatUser: {
          id: ''
        },
        chatIdentity: {
          id: ''
        }
      },
      {
        id: 4514,
        firstName: 'lambda-010',
        lastName: 'alpha',
        emails: [
          {
            address: 'G-010mobiledev@nagdom.com'
          }
        ],
        phones: [
          {
            number: '208-555-0010',
            priority: 0,
            phoneType: 'Business'
          },
          {
            number: '(208) 982-0291',
            priority: 0,
            phoneType: 'Cell'
          }
        ],
        importedId: 'GM010',
        chatUser: {
          id: ''
        },
        chatIdentity: {
          id: ''
        }
      }
    ];
    return json;
  }

  protected createGenerated(): Contact[] {
    return [];
  }
}
export const contactData = ContactData.instance;
